import { CSSObject, Modal } from '@mantine/core';
import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  children: any;
  style?: CSSObject;
  inner?: CSSObject;
  content?: CSSObject;
}

function ModalComponent({ onClose, open, children, style, inner, content }: Props) {
  return (
    <Modal
      styles={{
        body: style,
        inner,
        content,
      }}
      opened={open}
      onClose={onClose}
      centered
      withCloseButton={false}
      size="auto"
      lockScroll={false}
    >
      {children}
    </Modal>
  );
}

export default ModalComponent;
